const Loader = () => (
  <div className="flex justify-center items-center">
    <div className="w-5 h-5 border-2 border-t-2 border-white border-t-transparent rounded-full animate-spin" />
  </div>
);

export default Loader;